import { withStyles } from '@material-ui/core/styles';
import DialogContent from '@material-ui/core/DialogContent';

export default withStyles({
  root: {
    width: props => props.size === 'big' ? 960 : 350,
  },
})(DialogContent);
